import { useSelector } from "react-redux";
import { connection_platform } from "../../../services/api";
import React, { useCallback, useMemo } from "react";

export const useSelectRouteActiveCall = (midiaId, numeroDoCliente) => {
  const routerGroupGroupedByMidiaId = useSelector(
    (state) => state.routerGroupGroupedByMidiaId
  );
  const PermissionRouter = useSelector((state) => state.routergroups);
  const [open, setOpen] = React.useState(false);

  const filtrarRotasDeVoz = useCallback((permrouter, numeroDoCliente) => {
    let chamado = numeroDoCliente.replace(/\D/g, "");
    // let chamado = document.getElementById("chamado").value.replace(/\D/g, "");

    let tipochamada = 0;
    let DDD = permrouter[0].areacodeid || "71";

    const valorfixo = [1, 2, 3, 4],
      valormovel = [5, 6, 7, 8, 9];
    const removeDigits =
      connection_platform.remove_digits || parseInt(midiaId) !== 1;

    if (
      removeDigits &&
      chamado.startsWith("0") &&
      !chamado.startsWith("00") &&
      !chamado.startsWith("0800")
    ) {
      chamado = chamado.substring(1);
    }

    function definirTipoChamada(mediaid, tipo) {
      const tipos = {
        fixoInterurbano: [3, 17, 19, 18, 20, 21, 23, 22, 24, 25],
        movelInterurbano: [4, 17, 19, 18, 20, 21, 23, 22, 13, 24, 25],
        fixoLocal: [1, 17, 19, 18, 20, 21, 23, 22, 24, 25],
        movelLocal: [2, 17, 19, 18, 20, 21, 23, 22, 13, 24, 25],
      };

      // Converte mediaid para inteiro
      const midiaConvertida = parseInt(mediaid, 10);

      // Se mediaid for 1, busca no objeto `tipos`, senão segue a lógica específica
      if (midiaConvertida === 1) {
        return tipos[tipo] ? tipos[tipo][midiaConvertida - 1] || 0 : 0;
      } else {
        const mapeamentoMidia = {
          2: 24,
          3: 22,
          4: 18,
          5: 17,
          6: 20,
          8: 19,
          9: 21,
          10: 23,
          12: 13,
          15: 26,
        };

        return mapeamentoMidia[midiaConvertida] || midiaConvertida;
      }
    }

    if (
      (chamado.length >= 10 || chamado.length === 8 || chamado.length === 9) &&
      !chamado.startsWith("00")
    ) {
      if (chamado.startsWith("55")) chamado = chamado.substr(2);
      if (chamado.length === 8 || chamado.length === 9) chamado = DDD + chamado;
    }

    let chamadoValidado = chamado.replace(/^0(?!0|800|300)/, "");
    console.log("INGENIUM_ACTVECALL_0 : ", chamado);

    let dddValidado =
      chamadoValidado.length >= 10 ? chamadoValidado.substr(0, 2) : "";

    console.log("INGENIUM_ACTVECALL_0 : ", chamadoValidado);

    if (
      chamadoValidado.length >= 10 &&
      !chamadoValidado.startsWith("00") &&
      !chamadoValidado.startsWith("0800")
    ) {
      if (valorfixo.includes(parseInt(chamadoValidado[2]))) {
        tipochamada = definirTipoChamada(
          midiaId,
          dddValidado && parseInt(dddValidado) !== parseInt(DDD)
            ? "fixoInterurbano"
            : "fixoLocal"
        );
      } else if (valormovel.includes(parseInt(chamadoValidado[2]))) {
        tipochamada = definirTipoChamada(
          midiaId,
          dddValidado && parseInt(dddValidado) !== parseInt(DDD)
            ? "movelInterurbano"
            : "movelLocal"
        );
      }
    } else if (chamadoValidado.startsWith("0800")) {
      tipochamada = 8;
    } else if (chamadoValidado.startsWith("00")) {
      tipochamada = 5;
    } else {
    }

    let rota = [];

    console.log("INGENIUM_ACTVECALL_1 : ", permrouter);

    const doisPrimeirosDigitos = chamadoValidado.substring(0, 2);

    // Só verifica `areacode` se `mediaid` for 1
    const verificarAreacode = parseInt(midiaId) === 1;
    const verificarWhatsappInternacional = parseInt(midiaId) === 5;

    // Verifica se existe pelo menos um item com areacode correspondente (somente se `mediaid` for 1)
    const existeAreaCode = verificarAreacode
      ? permrouter.some(
          (result) =>
            result.areacode &&
            String(result.areacode).startsWith(doisPrimeirosDigitos)
        )
      : false;

    permrouter.forEach((result) => {
      if (
        result.calltypeid === tipochamada &&
        parseInt(result.idmidia) === parseInt(midiaId) &&
        (!verificarAreacode ||
          !existeAreaCode ||
          (result.areacode &&
            String(result.areacode).startsWith(doisPrimeirosDigitos)))
      ) {
        rota.push(result);
      }
      if (result.calltypeid === 11 && rota.length === 0) {
        if (
          parseInt(chamado) >= parseInt(result.partialnumber) &&
          parseInt(chamado) <= parseInt(result.partialnumber_end)
        ) {
          rota.push(result);
        }
      } else if (result.calltypeid === 6 && rota.length === 0) {
        if (parseInt(chamado) === parseInt(result.partialnumber)) {
          rota.push(result);
        }
      } else if (
        tipochamada === 5 &&
        midiaId === 5 &&
        result.calltypeid === 17
      ) {
        rota.push(result);
        chamado = chamado.replace(/^00/, "");
      }
    });

    console.log("INGENIUM_ACTVECALL_1222222 : ", rota);

    if (rota && rota.length > 1) {
      let isExistOther = false;
      rota.forEach((result) => {
        const lastEight = String(chamado).slice(-8);
        if (
          parseInt(lastEight) >= parseInt(result.partialnumber) &&
          parseInt(lastEight) <= parseInt(result.partialnumber_end)
        ) {
          rota = result;
          isExistOther = true;
        }
      });
    }

    return rota;
  }, []);

  /** @type {any[]} */
  const routeOptions = useMemo(() => {
    const hasRoutes =
      Boolean(routerGroupGroupedByMidiaId) &&
      typeof routerGroupGroupedByMidiaId === "object" &&
      midiaId in routerGroupGroupedByMidiaId;
    if (!hasRoutes) return [];
    if (!Array.isArray(routerGroupGroupedByMidiaId[midiaId])) return [];
    const isVoice = midiaId === 1;
    if (isVoice) {
      //aqui vai filtrar as rotas de acordo com o numeroDoCliente
      const voiceRoutes = filtrarRotasDeVoz(
        routerGroupGroupedByMidiaId[midiaId],
        numeroDoCliente
      );
      const hasVoiceRoutes = Array.isArray(voiceRoutes);
      if (!hasVoiceRoutes) return [];

      return voiceRoutes;
    }
    return routerGroupGroupedByMidiaId[midiaId];
  }, [routerGroupGroupedByMidiaId, numeroDoCliente, filtrarRotasDeVoz]);

  const numberOfRoutes = routeOptions.length;

  return {
    routeOptions,
    PermissionRouter,
    numberOfRoutes,
    open,
    setOpen,
  };
};
